import styled from "@emotion/styled";
import { fontFredoka, theme } from "@product/scmp-sdk";

import EncourageImage from "./encourage.svg?url";
import HighQualityContentImage from "./high-quality-content.png";
import LearningByDoingImage from "./learning-by-doing.png";

export const TextContainer = styled.div`
  flex: 1;
`;

export const Title = styled.div`
  margin-block-end: 16px;

  color: #389810;
  font-weight: 600;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: -0.01em;
  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    text-align: start;
  }
  ${theme.breakpoints.up("desktop")} {
    font-size: 32px;
    line-height: 36px;
  }
`;

export const Description = styled.div`
  font-size: 16px;
  line-height: 22px;

  ${theme.breakpoints.up("desktop")} {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const ImageContainer = styled.div`
  position: relative;

  aspect-ratio: 1/1;

  max-inline-size: 200px;
  margin-block-end: 16px;
  &::after {
    position: absolute;
    content: "";
  }
  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 0;
    margin-inline-end: 20px;
  }
  ${theme.breakpoints.up("desktop")} {
    max-inline-size: none;
    margin-block-end: 32px;
    margin-inline-end: 0;
  }
`;

export const Image = styled.img`
  max-inline-size: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;

  font-family: ${fontFredoka};
  &:first-child ${ImageContainer}::after {
    inset-block-start: 4%;
    inset-inline-start: 6%;

    inline-size: 83px;
    block-size: 114px;

    background-image: url(${HighQualityContentImage.src});

    ${theme.breakpoints.up("tablet")} {
      inset-block-start: -14%;
      inset-inline-start: 3%;

      inline-size: 83px;
      block-size: 114px;
    }
    ${theme.breakpoints.up("desktop")} {
      inline-size: 118px;
      block-size: 161px;
    }
    ${theme.breakpoints.up("largeDesktop")} {
      inline-size: 162px;
      block-size: 222px;
    }
  }

  &:nth-child(2) ${ImageContainer}::after {
    inset-block-start: -4%;
    inset-inline-end: -6%;

    inline-size: 93px;
    block-size: 118px;

    background-image: url(${LearningByDoingImage.src});

    ${theme.breakpoints.up("tablet")} {
      inset-block-start: -6%;
      inset-inline-end: -8%;

      inline-size: 89px;
      block-size: 118px;
    }

    ${theme.breakpoints.up("desktop")} {
      inline-size: 118px;
      block-size: 161px;
    }

    ${theme.breakpoints.up("largeDesktop")} {
      inline-size: 173px;
      block-size: 240px;
    }
  }

  &:nth-child(3) ${ImageContainer}::after {
    inset-block-start: -20%;
    inset-inline-end: -48%;

    inline-size: 320px;
    block-size: 237px;

    background-image: url(${EncourageImage});

    ${theme.breakpoints.up("tablet")} {
      inset-block-start: -9%;
      inset-inline-end: -9%;

      inline-size: 185px;
      block-size: 133px;
    }

    ${theme.breakpoints.up("desktop")} {
      inset-block-start: -11%;
      inset-inline-end: -15%;

      inline-size: 248px;
      block-size: 221px;
    }

    ${theme.breakpoints.up("largeDesktop")} {
      inset-block-start: -13%;
      inset-inline-end: -7%;

      inline-size: 324px;
      block-size: 239px;
    }
  }

  ${ImageContainer}::after {
    background-repeat: no-repeat;
    background-size: contain;
  }

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
  }
  ${theme.breakpoints.up("desktop")} {
    display: block;
  }
`;
